"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var FileUploadComponent = /** @class */ (function () {
    function FileUploadComponent(messageService, element) {
        this.messageService = messageService;
        this.element = element;
        this.component = 'wf-import';
        this.valueChange = new core_1.EventEmitter();
        this.onFileChanged = new core_1.EventEmitter();
    }
    FileUploadComponent.prototype.ngOnInit = function () {
    };
    FileUploadComponent.prototype.processFileDrop = function (event) {
        event.stopPropagation();
        event.preventDefault();
        this.processUploadedFile(event.dataTransfer.files && event.dataTransfer.files[0]);
    };
    FileUploadComponent.prototype.processFileUpload = function (event) {
        this.processUploadedFile(event.target.files && event.target.files[0]);
    };
    FileUploadComponent.prototype.processUploadedFile = function (fileData) {
        var _this = this;
        if (fileData) {
            var fileReader = new FileReader();
            fileReader.onloadend = function (event) {
                _this.value = {
                    lastModified: fileData.lastModified,
                    name: fileData.name,
                    extension: _this.getFileExtension(fileData.name),
                    type: fileData.type,
                    data: event.target.result,
                    file: fileData
                };
                _this.valueChange.emit(_this.value);
                _this.onFileChanged.emit(_this.value);
                // console.log('processUploadedFile', fileData, this.value);
            };
            /*
            
                        lastModified: 1591886252917
                        lastModifiedDate: Thu Jun 11 2020 18:37:32 GMT+0400 (Armenia Standard Time) {}
                        name: "process.json"
                        size: 603
                        type: "application/json"
                        webkitRelativePath: ""
            
                        */
            fileReader.readAsText(fileData);
        }
    };
    FileUploadComponent.prototype.deleteFile = function () {
        this.value = null;
        this.valueChange.emit(this.value);
        this.onFileChanged.emit(this.value);
    };
    FileUploadComponent.prototype.fileUploadTrigger = function () {
        this.fileUploadInput.nativeElement.click();
    };
    FileUploadComponent.prototype.getFileExtension = function (file) {
        var parts = file.split('.');
        return parts[parts.length - 1].toLowerCase();
    };
    FileUploadComponent.prototype.getMessage = function (key) {
        return this.messageService.getMessage(key);
    };
    FileUploadComponent.decorators = [
        { type: core_1.Component, args: [{
                    
                    selector: 'file-upload-component',
                    template: require('./file-upload.component.html')
                },] },
    ];
    /** @nocollapse */
    FileUploadComponent.ctorParameters = function () { return [
        { type: idm_message_language_service_client_js_1.MessageService, },
        { type: core_1.ElementRef, },
    ]; };
    FileUploadComponent.propDecorators = {
        "component": [{ type: core_1.Input },],
        "fileUploadInput": [{ type: core_1.ViewChild, args: ['fileUploadInput',] },],
        "value": [{ type: core_1.Input },],
        "valueChange": [{ type: core_1.Output },],
        "onFileChanged": [{ type: core_1.Output },],
    };
    return FileUploadComponent;
}());
exports.FileUploadComponent = FileUploadComponent;
//# sourceMappingURL=file-upload.component.js.map